const ProjectUserPermissions = {
  EditApprovers: "EditApprovers",
  EditMilestoneComments: "EditMilestoneComments",
  EditMilestoneTargetDates: "EditMilestoneTargetDates",
  EditMilestoneActualDates: "EditMilestoneActualDates",
  EditMilestoneDocument: "EditMilestoneDocument",
  EditNotified: "EditNotified",
  EditProjectImages: "EditProjectImages",
  EditProjectLeaders: "EditProjectLeaders",
  EditProjectRoles: "EditProjectRoles",
  EditProjectSkus: "EditProjectSkus",
  EditStatusKpis: "EditStatusKpis",
  EditSchedules: "EditSchedules",
  SubmitAndReleaseMilestones: "SubmitAndReleaseMilestones",
  ResetCompleteMilestones: "ResetCompleteMilestones",
  ViewMilestoneDropdownOptions: "ViewMilestoneDropdownOptions",
  AddMilestones: "AddMilestones",
  ViewScheduleDropdown: "ViewScheduleDropdown",
  EditCompletedProject: "EditCompletedProject",
};

export default ProjectUserPermissions;
